/* eslint-disable no-underscore-dangle */
import React, {useEffect, useState} from 'react';
import Doc from 'assets/svgs/ext/doc.svg';
import JPG from 'assets/svgs/ext/jpg.svg';
import PDF from 'assets/svgs/ext/pdf.svg';
import PNG from 'assets/svgs/ext/png.svg';
import SVG from 'assets/svgs/ext/svg.svg';
import ZIP from 'assets/svgs/ext/zip.svg';
import {ReactComponent as CheckIcon} from 'assets/svgs/actions/confirm-delete-check.svg';
import LoadingIndicator from 'components/LoadingIndicator';
import useClickPreventionOnDoubleClick from 'hooks/useDoubleClick';
import {searchDocuments} from 'utils/fetch';
import {ReactComponent as FolderSVG} from 'assets/svgs/file-upload/folder-svg.svg';
import BreadCrumb from './Breadcrumb';

const getFileIcon = (post) => {
  const {name} = post;
  const ext = name.split('.').pop();

  switch (ext) {
    case 'pdf':
      return (
        <img
          alt="test"
          src={PDF}
          height={post.isOuter ? 30 : 25}
          className="mr-2"
        />
      );
    case 'docx':
    case 'doc':
    case 'xls':
    case 'xlsx':
      return (
        <img
          alt="test"
          src={Doc}
          height={post.isOuter ? 30 : 25}
          className="mr-2"
        />
      );

    case 'mp3':
    case 'ogg':
    case 'wav':
    case 'mp4':
    case 'mov':
      return (
        <img
          alt="test"
          src={File}
          height={post.isOuter ? 30 : 25}
          className="mr-2"
        />
      );
    case 'zip':
    case '7z':
    case 'rar':
      return (
        <img
          alt="test"
          src={ZIP}
          height={post.isOuter ? 30 : 25}
          className="mr-2"
        />
      );
    case 'jpg':
    case 'jpeg':
    case 'webp':
      return (
        <img
          alt="test"
          src={JPG}
          height={post.isOuter ? 30 : 25}
          className="mr-2"
        />
      );
    case 'png':
      return (
        <img
          alt="test"
          src={PNG}
          height={post.isOuter ? 30 : 25}
          className="mr-2"
        />
      );
    case 'svg':
      return (
        <img
          alt="test"
          src={SVG}
          height={post.isOuter ? 30 : 25}
          className="mr-2"
        />
      );
    default:
      return (
        <FolderSVG
          color={post.colour ? post.colour : '#fcd297'}
          className="mr-2"
          height={30}
        />
      );
  }
};

const MoveExisting = ({
  searchKey,
  userDetails,
  setSearchKey,
  onClose,
  list,
  onMove,
  companyId,
}) => {
  const [selected, setSelected] = useState(null);
  const [inside, setInside] = useState(null);
  const [selectedTab, setSelectedTab] = useState(null);
  const [folders, setFolders] = useState([]);
  const [breadcrumb, setBreadcrumb] = useState([]);
  const [loading, setLoading] = useState(true);
  const [load, setLoad] = useState();
  const [file, setHovered] = useState(null);
  const onClick = () => {
    setSelected(file);
  };

  const onDoubleClick = () => {
    setSearchKey('');
    const newBreadCrumb = [...breadcrumb];
    newBreadCrumb.push(file);
    setBreadcrumb(newBreadCrumb);
    setInside(file);
    setSelected(null);
    setFolders([]);
    setTimeout(() => {
      setLoad(Math.random());
      setHovered(null);
    }, 100);
  };

  const [handleClick, handleDoubleClick] = useClickPreventionOnDoubleClick(
    onClick,
    onDoubleClick
  );

  const getFolders = async () => {
    setLoading(true);

    const params = {
      searchKey,
    };

    if (inside) {
      params.folderId = inside._id;
    }

    const folderList = await searchDocuments({
      authToken: userDetails.authToken,
      filters: params,
      companyId,
    });

    setFolders(
      folderList.filter(
        (f) => !list.find((l) => l._id === f._id) && !f.isSpecial
      )
    );
    setLoading(false);
  };

  useEffect(() => {
    getFolders();
  }, [load, searchKey]);

  const loadFolders = () => {
    if (loading) {
      return <LoadingIndicator />;
    }
    return folders
      .filter((f) => f.folderType !== 'FILE')
      .map((tab, index) => (
        <div
          aria-hidden
          key={tab._id}
          onMouseEnter={() => setHovered(tab)}
          onClick={handleClick}
          onDoubleClick={handleDoubleClick}
          className={`d-flex px-4 pointer align-items-center ${
            selected && selected._id === tab._id ? 'bg-gold' : ''
          } py-2 ${index + 1 === folders.length ? '' : 'border-bottom'}`}
        >
          {getFileIcon(tab)} {tab.name}
        </div>
      ));
  };
  return (
    <div className="d-flex move-existing flex-column">
      <div className="header d-flex border-bottom px-3 align-items-center">
        <BreadCrumb
          tab={selectedTab ? selectedTab.name : ''}
          list={breadcrumb}
          onClick={(folder) => {
            if (!folder) {
              setSelectedTab(null);
              setFolders([]);
              setSelected([]);
              setInside(null);
            } else {
              const newBreadCrumm = [];
              breadcrumb.every((f) => {
                if (f._id !== folder._id) {
                  newBreadCrumm.push(f);
                  return true;
                }
                newBreadCrumm.push(f);
                return false;
              });

              setBreadcrumb(newBreadCrumm);
              setInside(folder);
            }
          }}
          setSelectedTab={() => {
            setSelectedTab(null);
            setFolders([]);
            setSelected([]);
            setInside(null);
          }}
        />
      </div>

      <div className="d-flex flex-column border-bottom move-body">
        {loadFolders()}
      </div>

      <div className="d-flex move-footer px-3 justify-content-between align-items-center">
        <span>Move file/folder to selected folder</span>
        <button
          type="button"
          className="cat-delete"
          disabled={!selected}
          onClick={() => {
            const moveSelected = selected || inside || null;
            onMove(moveSelected);
            onClose();
          }}
        >
          <CheckIcon className="mr-2" />
          Confirm
        </button>
      </div>
    </div>
  );
};

export default MoveExisting;
